<template>
    <div class="">
        <input
            class="textfield"
            :id="id"
            :name="name"
            :type="type"
            :autocomplete="autocomplete"
            :ref="innerRef"
            :class="inputClass"
            :placeholder="placeholder"
            :value="value"
            :required="required"
            :disabled="disabled"
            :maxlength="maxlength"
            @input="$emit('input', $event.target.value)"
            @blur="$emit('blur', $event.target.value)"
            @keydown.enter="$emit('keydownenter', $event.target.value)"
            @keydown.esc="$emit('keydownesc', $event.target.value)"
            @keydown="$emit('keydown', $event.target.value, $event)"
            @paste="$emit('paste', $event)"
            @focus="$emit('focus', $event)"
        />
    </div>
</template>

<script>
export default {
    name: "Textfield",
    props: {
        name: String,
        innerRef: String,
        inputClass: {
            type: String,
            default: "",
        },
        placeholder: String,
        value: String,
        required: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        id: String,
        type: {
            type: String,
            default: 'text'
        },
        autocomplete: {
            type: String,
            default: 'on'
        },
        maxlength: Number
    },
    data() {
        return {};
    },
    methods: {
        handleInput(event) {
            // Обмеження кількості символів
            if (this.maxlength && event.target.value.length > this.maxlength) {
                event.target.value = event.target.value.slice(0, this.maxlength);
                this.$emit('input', event.target.value);
            } else {
                this.$emit('input', event.target.value);
            }
        }
    },
};
</script>

<style scoped lang="scss">
.textfield {
    font-size: 16px;
    text-align: left;
    margin-bottom: 12px;
    border-radius: 10px;
    width: 100%;
    display: block;
    padding: 10px;
    background: var(--primary-bg);
    border: 0.5px solid var(--outline);
    color: var(--primary-text);

    &:disabled {
        border-color: var(--outline);
        font-size: normal;
        text-align: left;
        margin-bottom: 12px;
        width: 100%;
        display: block;
        padding: 10px;
        color: #9A9A9A;
    }
    &::placeholder {
        opacity: 1;
        color: var(--placeholder);
    }

    &[type="date"] {
        color-scheme: dark;
    }

    &:focus-visible {
        outline: var(--outline-active);
        
    }
}
</style>
